"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayArrowIcon = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("@emotion/react");
const PlayArrowIcon = (_a) => {
    var { color } = _a, props = __rest(_a, ["color"]);
    const theme = (0, react_1.useTheme)();
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ width: "34", height: "39", viewBox: "0 0 34 39", fill: "none" }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: "M34 19.5L0.250002 38.9856L0.250004 0.0144276L34 19.5Z", fill: color !== null && color !== void 0 ? color : theme.colors.white }) })));
};
exports.PlayArrowIcon = PlayArrowIcon;
//# sourceMappingURL=play_arrow_icon.js.map